export default __webpack_public_path__ + "static/media/approvalTask.52ebee90.png";